import { css } from '@/styled-system/css';

const GRADIENT_BACKGROUND =
  'linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.80) 60%, #FFF 100%)';

export const compactContainerStyles = css.raw({
  display: 'flex',
  flexShrink: 0,
  padding: 'default',
  width: '100%',
  overflowX: 'auto',
  background: GRADIENT_BACKGROUND,
});

export const defaultContainerStyles = css.raw({
  display: 'flex',
  flex: '0 0 auto',
  position: 'sticky',
  bottom: 0,
  zIndex: 10,
  width: '98%',
  overflowX: 'auto',
  padding: 'default',
  background: GRADIENT_BACKGROUND,
  marginTop: '-56px',
});
